"use strict";

import Vue from 'vue';
import axios from "axios";
import store from "../store";
import VueCookies from "vue-cookies";
import { v4 as uuidv4 } from 'uuid';

Vue.use(VueCookies)

// Generate or retrieve device_id
let deviceId = localStorage.getItem('device_id');
if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem('device_id', deviceId);
}

let token = Vue.$cookies.get('token')

// Axios config for protected API
let config = {
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        Authorization: token,
        'X-Device-Id': deviceId
    }
};

// Axios config for public API
let configMain = {
    baseURL: process.env.VUE_APP_BASE_URL_DEFAULT
};

const _axios = axios.create(config);
const _axiosMain = axios.create(configMain);

_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        store.commit("setLoading", false)
        // Do something with response data
        return response;
    },
    function (error) {
        store.commit("setLoading", false)
        // Do something with response error
        return Promise.reject(error);
    }
);

const Plugin = {};
Plugin.install = function (Vue) {
    Vue.axios = _axios;
    Vue.mainAxios = _axiosMain;
    window.axios = _axios;
    window.mainAxios = _axiosMain;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        }
    });
};

Vue.use(Plugin)

export default Plugin;
